export default "<div class=\"m-loader m-loader--brand loader\">\n    <div class=\"show-text\">Please Wait</div>\n</div>";